function Loading() {
    return (
        <section className="w-full h-screen flex justify-center items-center bg-black">
            <span className="loader scale-[2]"></span>
        </section>
    );
}

export default Loading;